import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventTrackingService } from '../../../../services/event-tracking.service';

@Component({
  selector: 'app-opt-in-modal-disclosure',
  templateUrl: './opt-in-modal-disclosure.component.html',
  styleUrls: ['./opt-in-modal-disclosure.component.scss', './styles.scss'],
  standalone: false,
})
export class OptInModalDisclosureComponent implements OnInit {
  customerPortalDisclosureText = `Credit Profile Authorization
  (Personal Loans)
  By agreeing to this Credit Profile Authorization and submitting your
  application, you are providing “written instructions” under the Fair Credit
  Reporting Act authorizing Marlette Marketing, LLC and its affiliates (together
  “Best Egg”) and their lending partners, and each of their respective third-
  party service providers, (each, an “Authorized Party” and, collectively, the
  “Authorized Parties”) to obtain consumer reports and related information
  about you, now and periodically, from one or more credit reporting agencies.
  This information will be used by the Authorized Parties to (a) evaluate you for
  any Best Egg products (including, but not limited to, for the purpose of
  evaluating and processing your initial application); (b) to service, collect,
  review, administer, or enforce your credit account; (c) to market other
  products and services to you; (d) for data analysis and internal use; and/or
  (e) as the law permits. Your initial application will result in a soft inquiry, also
  known as a “soft pull,” on your credit report, and checking your rates will not
  impact your credit score.
  You certify that the information you have provided is true and correct and
  you understand it will be relied upon by the Authorized Parties in evaluating
  you for credit offers and to see if you qualify for more products than the one
  you applied for. You agree that the Authorized Parties may (i) verify the
  information provided by and (ii) report credit experience information about
  you to the consumer reporting agencies.
  Upon acceptance of an offer, a “hard inquiry,” also known as a “hard pull,”
  will be made to the consumer reporting agencies and will appear on your
  credit report.
  Notice to New York Residents: Upon your request, we will inform you whether
  or not a consumer report was requested in connection with your credit
  application and, if so, we will inform you of the name and address of the
  consumer reporting agency that furnished the report. You can call us at 1-
  855-282-6353 to make a request. We may also request and use subsequent
  consumer reports about you in connection with the update, renewal, or
  extension of your credit account, and as otherwise authorized above.
  Notice to Vermont Residents: If we request or use subsequent credit reports
  about you pursuant to your above authorization, we will do so only for the
  purposes of reviewing your account, increasing your credit line (if applicable)
  or taking collection action on your account, or for other legitimate purposes
  associated with your account, notwithstanding the above authorization.`;
  constructor(
    private readonly eventTrackingService: EventTrackingService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  closeDisclosureModal() {
    this.eventTrackingService.trackEnterpriseEvent({
      customerPortalClickLinkText: 'Exit CPA Disclosure',
      customerPortalClickLinkType: 'exitDisclosure',
      eventRepo: 'customerPortal',
      eventName: 'linkClick',
      cid: this.data.cid,
    });
  }

  ngOnInit(): void {
    this.eventTrackingService.trackEnterpriseEvent({
      eventRepo: 'customerPortal',
      optInDisplayType: 'disclosure modal',
      eventName: 'optInDisplayed',
      customerPortalDisclosureText: this.customerPortalDisclosureText,
      cid: this.data.cid,
    });
  }
}
